import React from 'react';
import crypto from 'crypto';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  Container, Label, Input, Error, Optional,
} from './css';

const AddressInput = ({
  input,
  id,
  label,
  optional,
  meta: { touched, error },
  logInError,
}) => {
  const labelPrefix = id || (crypto.randomBytes(8).toString('hex') + label);

  return (
    <Container logInError={logInError?.shipperAddress || logInError?.consigneeAddress}>
      <Label htmlFor={labelPrefix + label}>
        {label}
        {' '}
        {optional && (
        <Optional>
          (
          {t('Optional')}
          )
        </Optional>
        )}
      </Label>
      <Input
        {...input}
        id={labelPrefix}
        type="address"
        autoComplete="off"
      />
      {(touched && error) && (
        <Error>{error}</Error>
      )}
    </Container>
  );
};

AddressInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
  }),
  id: PropTypes.string,
  label: PropTypes.string,
  optional: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  logInError: PropTypes.shape({
    shipperAddress: PropTypes.string,
    consigneeAddress: PropTypes.string,
  }),
};

export default AddressInput;
